import 'whatwg-fetch';
const env = process.env;

const getMonthlyTotalYieldByStrain = (params) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/lifecycleLog/getMonthlyTotalYieldByStrain?access_token=${params.access_token}&strain_id=${params.selectedStrain}&startdate=${params.startDate}&days=${params.diffDays}&facility_id=${params.facility_id}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
		}
	});
}

const getMonthlyTotalYield = (params) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/lifecycleLog/getMonthlyTotalYield?access_token=${params.access_token}&startdate=${params.startDate}&days=${params.diffDays}&facility_id=${params.facility_id}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
		}
	});
}

const getInFlight = (params) => {
    	return fetch(`${env.VUE_APP_trimaster}/api/v1/ag_inFlightLifecycles/getInFlight?access_token=${params.access_token}&facility_id=${params.facility_id}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
		}
	});
}

export default {
  getMonthlyTotalYieldByStrain,
  getMonthlyTotalYield,
  getInFlight
}